import { Injectable } from '@angular/core';
import { BillingOffersObject } from 'src/app/models/orders/order-details-billing/billing-offers/billing-offers-object.model';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined, isUndefined } from 'util';
import { BillingInventoryResponse } from 'src/app/models/orders/order-details-billing/billing-inventory-response';
import { UpdateBillingDateRequestModel } from 'src/app/models/billing/update-billing-date-request/update-billing-date-request.model';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { UpdateBillingCharacteristicsRequestModel } from 'src/app/models/billing/update-billing-characteristics-request/update-billing-characteristics-request.model';
import { CharacteristicsConverter } from '../characteristics/characteristics.converter';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';

@Injectable({
    providedIn: 'root'
})
export class BillingOffersService {

    appData: any;

    constructor(private characteristicsConverter: CharacteristicsConverter, appService: AppService,
        private httpClient: HttpClient, private billingOffersService: BillingOffersService) {
        this.appData = appService.settings;
    }

    public async getOffersList(productId: string): Promise<BillingInventoryResponse> {
        const response: any = await this.httpClient.get(`${this.appData.webApi}/billing/${productId}`);
        const billingData = JSON.parse(JSON.stringify(response.data));

        const list = new Array<BillingOffersObject>();
        let billingDate: string = null;
        let id = 0;
        if (!isNullOrUndefined(billingData) && !isNullOrUndefined(billingData.billingList)) {
            billingDate = billingData.billingDate;
            for (const offer of billingData.billingList) {
                const characteristics = this.characteristicsConverter.convert(offer.characteristics);
                list.push(new BillingOffersObject(
                    id++, offer.offer, offer.price, offer.discount != null ? offer.discount : 0.0,
                    offer.description, characteristics.inputCharacteristics, characteristics.outputCharacteristics));
            }
        }
        return new BillingInventoryResponse(billingDate, list);
    }

    public async updateBillingDate(orderId: string, $event: any) {
        const request = new UpdateBillingDateRequestModel($event, 'Billing date updated');
        await this.httpClient.post(`${this.appData.webApi}/billing/updateBillingDate?orderId=${orderId}`, request);
    }

    public async updateBillingChars(orderId: string, $event: CharacteristicsObject, offerName: string) {
        const productOffering = {};
        for (const char of $event.inputCharacteristics) {
            productOffering[char.id] = char.value;
        }
        for (const char of $event.outputCharacteristics) {
            productOffering[char.id] = char.value;
        }
        if (isUndefined(productOffering)) {
            console.warn('There are no characteristics changes.');
            return;
        }
        const request = new UpdateBillingCharacteristicsRequestModel(productOffering, offerName, 'Billing characteristics updated.');
        await this.httpClient.post(`${this.appData.webApi}/billing/updateBillingChars?orderId=${orderId}`, request);
    }
}
